import BinValueConverterBase from "./BinValueConverterBase.js";

class BinToRationConverter extends BinValueConverterBase {
    constructor(binToQuantityConverter, binToTotalConverter, silent, defaultValue) {
        if (!(binToQuantityConverter instanceof BinValueConverterBase)) {
            throw new TypeError('binToQuantityConverter must be an instance inheriting from BinValueConverterBase class');
        }
        if (!(binToTotalConverter instanceof BinValueConverterBase)) {
            throw new TypeError('binToTotalConverter must be an instance inheriting from BinValueConverterBase class');
        }
        super(silent, defaultValue);

        this.binToQuantityConverter = binToQuantityConverter;
        this.binToTotalConverter = binToTotalConverter;
    }

	_getBinValue(bin, customData) {
		if (!(customData instanceof Array)){
            throw new TypeError('customData must be an array');
        }

        const quantity = this.binToQuantityConverter.getBinValue(bin, customData);
        const total = this.binToTotalConverter.getBinValue(bin, customData);

        if (total === 0) {
            throw new Error('total cannot be 0');
        }

        if (Number.isNaN(quantity) || quantity === null) {
            throw new TypeError('quantity must be numeric');
        }

        if (Number.isNaN(total) || total === null) {
            throw new TypeError('total must be numeric');
        }

        return this._determineRatio(quantity, total);
    }
    
    _determineRatio(quantity, total) {
        return quantity / total;
    }
}

export default BinToRationConverter;